import { BalloonEventModel } from 'ts-core';
import React from 'react';
import { useTranslations } from '../..';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export function DescriptionSection({ event }: { event: BalloonEventModel }) {
  const { language, translated } = useTranslations();

  // Some scraped descriptions arrive wrapped like:
  //   <div itemprop="description">
  //                       <p>…</p>
  // Any line starting with 4+ spaces is treated as a markdown code block by
  // ReactMarkdown (the tokenizer runs before rehypeRaw parses HTML), producing
  // a raw-HTML-in-<pre> panel. Strip leading whitespace on lines that begin
  // with an HTML tag so rehypeRaw can take over cleanly. Intentional markdown
  // code blocks (lines not starting with `<`) are untouched.
  const raw = event.description?.getText(language);
  const description = raw?.replace(/^[ \t]+(?=<)/gm, '');
  return (
    <>
      {description && (
        <div className="balloon-section description-section">
          <div className="prose mt-4 text-md">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{description}</ReactMarkdown>
          </div>
        </div>
      )}
    </>
  );
}
